import api from '../api';

/**
 * Change the password for a user based on their phone number, old password, and new password.
 *
 * @param {string} oldPassword - The user's old password.
 * @param {string} newPassword - The user's new password.
 * @param {string} phone - The user's phone number.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const changePassword = async (oldPassword, newPassword) => {
  const endpoint = process.env.REACT_APP_API_ENDPOINT + "/api/user/changePassword";

  try {
    const response = await api.post(endpoint, { old_password: oldPassword, new_password: newPassword });
    return response.data;
  } catch (error) {
    console.error('Error while changing password:', error);
    throw error;
  }
}

export default changePassword;
